






















import { defineComponent } from "@vue/composition-api";
import { MessageThread } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { timeAgo } from "@/lib/time";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import MessagePreview from "@/components/MessagePreview";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "MessageThreadView",
  components: { MessagePreview, BasePage, BaseIcon, PageTitle, BaseAvatar },
  props: {
    messageThread: { type: Object as () => MessageThread, required: true },
    authUserId: { type: String, required: true },
    isBlocked: { type: Boolean, default: false },
  },
  computed: {
    to(): { name: string; params: { userId: string } } {
      const userId = this.messageThread.userIds.find(i => i !== this.authUserId) || this.authUserId;
      return { name: "messages", params: { userId } };
    },
    user(): UserPublicData | undefined {
      return (
        this.messageThread?.users.find(i => i.id !== this.authUserId) ??
        this.messageThread?.users.find(i => i.id === this.authUserId)
      );
    },
    screenName(): string {
      return this.user?.screenName ?? "";
    },
    timeData(): string {
      return timeAgo(this.messageThread.updatedTime);
    },
  },
});
